import { T_MongoDoc, T_MongoId } from "./_utils.types";

export enum LawSuitTypes {
  CREATED = "CREATED",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  RESOLVED = "RESOLVED",
  CLOSED = "CLOSED",
  DEFAULTED = "DEFAULTED",
}

export type LawSuitDto = {
  user: T_MongoId;
  loan_name?: string;
  loan?: T_MongoId;
  remarks?: string;
  status: LawSuitTypes;
  attachments: T_MongoId[];
};

export type LawSuitSchemaDto = LawSuitDto & T_MongoDoc;
export type CreateLawSuitDto = LawSuitSchemaDto;
export type UpdateLawSuitDto = Partial<LawSuitTypes>;
